import { Injectable } from '@angular/core';
import { AppSettingsService } from './app-settings.service';
import { DataTaskService } from './data-task.service';
import { UserStore } from './user.store';

/**
 * MyFontSize represents the my font size object containing page load.
 */
export interface MyFontSize {
    portal_user_keyno: string;   // stringified portal user key.
    user_name: string;           // the name of the user.
    fontsize: string;            // preferred font-size in pixels.
    fontsize_mobile: string;     // difference vs mobile, defaults to 0.
}

/**
 * BJS 20260218
 * myFontSizeService (Angular 15)
 *
 * Migrated from AngularJS factory("myFontSizeService").
 */
@Injectable({ providedIn: 'root' })
export class MyFontSizeService {
    constructor(private readonly dataTask: DataTaskService, private readonly appSettings: AppSettingsService, private readonly userStore: UserStore) { }

    public async loadMyFontSizeGet(): Promise<MyFontSize[]> {
        return await this.dataTask.Post(1833, {});
    }

    public async save(get: MyFontSize): Promise<any> {
        var response = await this.dataTask.Post(1834, get);

        // BJS 20260218 - Force update of user cache after updating settings
        await this.appSettings.triggerUserInfoCacheUpdate();

        // BJS 20260218 - Update userstore with update font settings after updating settings
        this.userStore.setFontSize(get.fontsize.toString());

        this.userStore.setFontSizeMobile(get.fontsize_mobile.toString());

        return response;
    }
}
